// extracted by mini-css-extract-plugin
module.exports = {"stickerContainer":"ProductStickers_stickerContainer__AWxWR","pinkSticker":"ProductStickers_pinkSticker__w-8Sh"};